const DEFAULT_RELEASE = {
  product: "Orkelys",
  version: "0.8.0-beta.2",
  releasedAt: "2026-09-08",
  edition: "Plateforme de création de site et de pilotage d'activité",
  website: "https://orekelys.fr",
};

const configuredVersion = process.env.REACT_APP_SOFTWARE_VERSION?.trim();
const configuredDate = process.env.REACT_APP_SOFTWARE_RELEASE_DATE?.trim();

export const SOFTWARE_RELEASE = Object.freeze({
  ...DEFAULT_RELEASE,
  version: /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-(?:alpha|beta|rc)\.(0|[1-9]\d*))?$/.test(configuredVersion || "") ? configuredVersion : DEFAULT_RELEASE.version,
  releasedAt: /^\d{4}-\d{2}-\d{2}$/.test(configuredDate || "") ? configuredDate : DEFAULT_RELEASE.releasedAt,
});

export const formatReleaseDate = value => new Intl.DateTimeFormat("fr-FR", {
  day: "numeric",
  month: "long",
  year: "numeric",
}).format(new Date(`${value}T12:00:00`));
